export enum Housekeeping {
  NotChecked = 0,
  Unsatisfactory = 1,
  Satisfactory = 2
}
